import { configureStore, combineReducers } from "@reduxjs/toolkit";
import pageReducer from "./page"
import userReducer from "./user"
import productsReducer from "./products"
import inventoryReducer from "./inventory"
import deliveryReducer from "./delivery";
import orderReducer from "./orders"
import deliveryPartner from "./delivery-partner";
import deliveryUser from "./deliveryUser";
import campaignReducer from './campaign'
import offerReducer from './offers'
import settingsReducer from './settings'
import categoryReducer from './category-redux'
import subcategoryReducer from './sub-category-redux'
import ProductBannerReducer from './product-banner'
import HomeBannerReducer from './home_banner'
import InstructionReducer from './add-instruction'
import LandingPageAdsReducer from './landing-page-ads'

let rootReducer = combineReducers({
    page: pageReducer,
    user: userReducer,
    products: productsReducer,
    inventory: inventoryReducer,
    orders: orderReducer,
    deliveryPartner:deliveryPartner,
    deliveryUser : deliveryUser,
    campaign: campaignReducer,
    offers: offerReducer,
    settings: settingsReducer,
    category: categoryReducer,
    subcategory: subcategoryReducer,
    productBanner: ProductBannerReducer,
    homeBanner: HomeBannerReducer,
    addInstruction : InstructionReducer,
    landingPageAds: LandingPageAdsReducer,
    delivery: deliveryReducer
  });

let store = configureStore({
    reducer:rootReducer,
});

export default store;